function apiBaseUrl() {
  return process.env.REACT_APP_API_BASE_URL;
}

export function apiV2UserContactsUrl(userId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/buyer_contacts`;
}

export function apiV2ContactUrl(contactId) {
  return `${apiBaseUrl()}/api/v2/buyer_contacts/${contactId}`;
}

export function apiV2PurchaseOrderContactsUrl(userId, purchaseOrderId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/purchase_orders/${purchaseOrderId}/buyer_contacts`;
}

export function apiV2InvoiceContactsUrl(userId, invoiceId) {
  return `${apiBaseUrl()}/api/v2/users/${userId}/invoices/${invoiceId}/buyer_contacts`;
}



// WEBPACK FOOTER //
// ./src/features/contacts/contactsApiUrls.js